import React from 'react';
import { TemplateComponentProps } from "../../containers/template_page/template_component/template_component";
import ProfessorComponent, { orderProfessors, ProfessorData, professorKey, getKeyword, getArea } from "../c69_faculty/professor_component";
import PageProgressBar from "../../containers/template_page/page_progress_bar/page_progress_bar";
import { TFunction } from "i18next";
import { Col, Container, Row } from "react-bootstrap";
import Dropdown, { Option } from "react-dropdown";
import DoubleTemplateComponent
    from "../../containers/template_page/double_template_component/double_template_component";
import { API_CONFIG } from "../../config/api_config";
import axios from "axios";
import TextSearchFilter from "../../common_components/text_search_filter/text_search_filter";
import { filterObj, toQueryString } from "../../utils/utils";
import "./c70_scholars.scss";


const C70_SCHOLARS_DATA_URLS = (language: string, params: { area?: string, selectkeyword?: string, keyword?: string }) => ({
    __data: `${API_CONFIG.BASE_URL + API_CONFIG.PROFESSORS_PATH}/${language}?${toQueryString(params)}`,
    __other_data: [`${API_CONFIG.BASE_URL}${API_CONFIG.PROFESSORS_AREAS_PATH}/${language}`,
    `${API_CONFIG.BASE_URL}${API_CONFIG.PROFESSORS_KEYWORDS_PATH}/${language}`
    ]
});

const ALPHABET = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split('');

class C70Scholars extends DoubleTemplateComponent<ProfessorData[]> {

    loadingRef = React.createRef<PageProgressBar>();

    constructor(props: TemplateComponentProps<ProfessorData[]>) {
        super(props);

        this.requireInternationalization = true;
    }

    componentDidMount(): void {
        this.fetchUsingQueryParams();
    }

    componentDidUpdate(prevProps: Readonly<TemplateComponentProps<ProfessorData[]>>, prevState: any, snapshot?: any): void {
        if (prevProps.language !== this.props.language) {
            this.fetchUsingQueryParams();
        }
    }

    /**
     * Fetch the data using the filters specified in the query parameters and update the state with the filters
     */
    fetchUsingQueryParams() {
        let params = filterObj(this.props.query, ["area", "keyword", "name", "letter"]);

        if (!params.letter) {
            params["letter"] = '';
        }
        if (!params.name) {
            params["name"] = '';
        }
        if (params.name) {
            params.letter = '';
        }

        this.setState(params);

        let data = C70_SCHOLARS_DATA_URLS(this.props.language, params);
        // if (!params.area && !params.keyword && !params.name) {
        //     data.__data = "";
        //     this.nextDataLoaded = true;
        //     this.setState({ data: [] }, () => this.onDataLoaded([]));
        // }
        this.doubleFetchWithData(data, false);
    }

    onDataLoaded(data: ProfessorData[]) {
        this.setState({
            data: orderProfessors(data)
        });
    }

    onOtherDataLoaded(index: number, data: any) {
        const areaExpert = data.filter((areas: any) => areas.hasOwnProperty('area'));
        const keyWord = data.filter((key: any) => key.hasOwnProperty('keyword'));

        if (data && data.length) {

            if (areaExpert.length) {
                this.setState({
                    areas: data.map((area: any) => ({ label: area.area, value: area.ID }))
                });
            }

            if (keyWord.length) {
                this.setState({
                    keywords: data.map((keyword: any) => ({ label: keyword.keyword, value: keyword.ID }))
                });
            }
        }
    }

    callFilter = () => {
        // if (!this.state.area && !this.state.keyword && !this.state.name) {
        //     this.updateQueryString({});
        //     this.setState({ data: [] });
        //     return;
        // }


        this.setState({ loading: true }, () => {
            if (this.loadingRef && this.loadingRef.current) {
                this.loadingRef.current.reset();
            }
        });

        const url = `${API_CONFIG.BASE_URL}${API_CONFIG.PROFESSORS_PATH}/${this.props.language}`;

        let params: any = {};
        if (this.state.area) {
            params["area"] = this.state.area;
        }

        if (this.state.keyword) {
            params["keyword"] = this.state.keyword;
        }

        if (this.state.name) {
            params["name"] = this.state.name;
        }

        if (this.state.letter) {
            params["letter"] = this.state.letter;
        }

        this.updateQueryString(params);

        axios.get(url, { params: params }).then(res => {
            this.setState({
                data: orderProfessors(res.data),
                loading: false
            });
        });
    };

    changeArea = (selected: Option) => {
        this.setState({ area: selected.value }, () => this.callFilter());
    };

    changeKeyword = (selected: Option) => {
        this.setState({ keyword: selected.value }, () => this.callFilter());
    };

    filterByLetter = (letter: string) => {
        this.setState({ letter: (this.state.letter === letter ? '' : letter) }, () => this.callFilter());
    };

    searchUpdated = (name: string) => {
        this.setState({ name: name, letter: name.length > 0 ? '' : this.state.letter }, () => this.callFilter());
    };



    internationalComponentRender(data: ProfessorData[], t: TFunction): React.ReactElement {
        getKeyword(data);
        getArea(data);

        const AREAS = [{
            label: t("C70 area placeholder"),
            value: ""
        }, ...this.state.areas ? this.state.areas : []];

        const KEYWORDS = [{
            label: t("C70 keyword placeholder"),
            value: ""
        }, ...this.state.keywords ? this.state.keywords : []];

        // On large screens, we show 3 professors per row, but if we have only 2 professors, we show only 2 columns
        let lgProfColSize = 4;
        if (data && data.length && data.length <= 2) {
            lgProfColSize = 6;
        }

        return (
            <div className="c70-scholars auto-margins">
                {this.state.loading && <PageProgressBar ref={this.loadingRef} speed={0.5} />}
                <Container fluid={true}>
                    <Row className="filters">
                        <Col xs={12} sm={6} md={4}>
                            <Dropdown
                                key="area-filter"
                                options={AREAS}
                                onChange={this.changeArea}
                                value={this.state.area}
                                placeholder={t("C70 area placeholder")}
                                className="area-filter" />
                        </Col>
                        <Col xs={12} sm={6} md={4}>
                            <Dropdown
                                key="keyword-filter"
                                options={KEYWORDS}
                                onChange={this.changeKeyword}
                                value={this.state.keyword}
                                placeholder={t("C70 keyword placeholder")}
                                className="keyword-filter" />
                        </Col>
                        <Col xs={12} md={4}>
                            <TextSearchFilter placeholder={t("C70 name placeholder")} continuous={true}
                                value={this.state.name} searchUpdated={this.searchUpdated} />
                        </Col>
                    </Row>
                    <Row>
                        {[ALPHABET.slice(0, 13), ALPHABET.slice(13, 26)].map(alphabet =>
                            <Col xs={12} sm={6} className="letter-filter" key={"letter-filter-col-" + alphabet[0]}>
                                {alphabet.map((letter) =>
                                    <span key={`letter-filter-${letter}`}
                                        className={"letter" + (letter === this.state.letter ? " active" : "")}
                                        onClick={() => this.filterByLetter(letter)}>{letter}</span>
                                )}
                            </Col>
                        )}
                    </Row>
                    <Row className="professors">
                        {(data && !!data.length) ?
                            data.map((professor: ProfessorData) =>
                                // we hide the professors that doesn't have areas and keywords. we do it here and not in professor_component
                                // because the empty div (col) would still exist
                                ((professor.areas.length !== 0) && (professor.keywords.length !== 0)) &&
                                <Col xl={lgProfColSize} lg={6} md={6} sm={12} xs={12} key={"professor-col-" + professorKey(professor)}>
                                    <ProfessorComponent {...professor} lang={this.props.language} valueKey={this.state.keyword} fullview={true} />
                                </Col>
                            )
                            :
                            (!this.state.loading && (this.state.area || this.state.keyword) ?
                                <div className="cards-no-result-text">{t("C70 no result")}</div>
                                :
                                <div className="cards-no-result-text">{t("C70 no filters")}</div>
                            )
                        }
                    </Row>
                </Container>
            </div>
        )
    }
}

export default C70Scholars;